module.exports = __webpack_public_path__ + "img/img82.68d3eb95.png";